var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMerchantDashboardReviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 43,
    viewBox: "0 0 40 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33334 39V4H36.6667V32H10L3.33334 39ZM15.125 25.4375L20 22.3313L24.875 25.4375L23.5833 19.6188L27.9167 15.6813L22.2083 15.2L20 9.6875L17.7917 15.2L12.0833 15.6813L16.4167 19.6188L15.125 25.4375Z",
    fill: "#F0B64F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchantDashboardReviewIcon);
export default __webpack_public_path__ + "static/media/merchant_dashboard_review_icon.d96ee9b4235b64d68073ada640dc3f03.svg";
export { ForwardRef as ReactComponent };